import React, { useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import ModelViewer from '../ModelViewer';
import assetUrl from '../../utils/assetUrl';

const Model = ({
  showModel,
  allowModelLoad,
  modelAvailable,
  modelUrl,
  fallbackImageSrc = assetUrl('stack-legs-down.png'),
  viewConfig = {}
}) => {

  useEffect(() => {
    if (allowModelLoad && modelAvailable) {
      useGLTF.preload(modelUrl);
    }
  }, [allowModelLoad, modelAvailable, modelUrl]);

  useEffect(() => {
    if (!allowModelLoad || !modelAvailable) {
      useGLTF.clear(modelUrl);
    }
  }, [allowModelLoad, modelAvailable, modelUrl]);

  const renderModel = allowModelLoad && modelAvailable;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
      {renderModel && (
        <div
          style={{
            opacity: showModel ? 1 : 0,
            pointerEvents: showModel ? 'auto' : 'none',
            transition: 'opacity 0.35s ease',
            position: 'absolute',
            inset: 0
          }}
        >
          <ModelViewer
            key={showModel ? 'model-visible' : 'model-hidden'}
            url={modelUrl}
            className="aero-model-viewer"
            width={800}
            height={600}
            autoRotate={true}
            environmentPreset="sunset"
            minZoomDistance={1}
            maxZoomDistance={10}
            autoFrame={true}
            fadeIn={true}
            enableManualRotation={true}
            enableManualZoom={false}
            enableMouseParallax={false}
            enableHoverRotation={false}
            showScreenshotButton={false}
            {...viewConfig}
          />
        </div>
      )}

      <div
        style={{
          width: '100%',
          maxWidth: 800,
          height: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto',
          opacity: showModel ? 0 : 1,
          pointerEvents: showModel ? 'none' : 'auto',
          transition: 'opacity 0.35s ease'
        }}
      >
        <img
          src={fallbackImageSrc}
          alt="EVE 2D View"
          style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center' }}
        />
      </div>
    </div>
  );
};

export default Model;
